import React from 'react';
import styled, { css } from 'styled-components';
import CopyTextBlock from '~/components/molecule/CopyTextBlock';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import { isProduction } from '~/util';

const AccountIdBadge = () => {
  const currentAccount = useCurrentAccount();

  const isDev = isProduction() !== true;
  if (!isDev) return null;

  return (
    <Container>
      <CopyTextBlock label="Account ID" textToCopy={currentAccount.id} />
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.space('xl')};
    right: ${theme.space('xl')};
    z-index: ${theme.z('top')} + 100;
    pointer-events: all;
  `,
);

export default AccountIdBadge;
